<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="411px"
    height="450px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 26.56 29.05"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <defs>
      <font
        id="FontID0"
        horiz-adv-x="778"
        font-variant="normal"
        style="fill-rule: nonzero"
        font-weight="900"
      >
        <font-face font-family="Arial Black">
          <font-face-src>
            <font-face-name name="Arial Black Normal" />
          </font-face-src>
        </font-face>
        <missing-glyph><path d="M0 0z" /></missing-glyph>
        <glyph
          unicode="C"
          horiz-adv-x="778"
          d="M550.204 293.11l194.074 -58.5254c-13.0026,-54.3499 -33.513,-99.8659 -61.6877,-136.215 -28.0114,-36.5121 -62.6941,-64.0203 -104.375,-82.5313 -41.5173,-18.5043 -94.371,-27.8414 -158.561,-27.8414 -78.0294,0 -141.553,11.3365 -191.068,33.8463 -49.3515,22.673 -91.8685,62.5241 -127.714,119.377 -35.8456,56.8525 -53.8535,129.883 -53.8535,218.583 0,118.377 31.5137,209.409 94.5343,273.103 63.1906,63.5238 152.386,95.3639 267.764,95.3639 90.2023,0 161.227,-18.171 212.911,-54.6831 51.5209,-36.5189 90.0391,-92.5349 115.045,-168.232l-195.073 -43.1834c-6.83454,21.6733 -14.0023,37.5118 -21.5033,47.5154 -12.5062,16.8449 -27.6782,29.8476 -45.5228,38.8515 -18.001,9.16712 -38.0082,13.6691 -60.1848,13.6691 -50.3512,0 -88.8694,-20.1704 -115.541,-60.3548 -20.1772,-29.8408 -30.3508,-76.8597 -30.3508,-140.717 0,-79.3623 12.0097,-133.549 36.1857,-163.063 24.1759,-29.3443 58.0222,-44.0131 101.702,-44.0131 42.3469,0 74.3639,11.8329 96.0372,35.6756 21.6733,23.6795 37.3485,58.1922 47.1821,103.375z"
        />
      </font>
    </defs>
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M12.47 23.34l0 2.32c-0.46,0.01 -2.86,-0.37 -3.48,-0.47 -1.91,-0.31 -4.66,-0.85 -6.43,-1.52 -0.49,-0.19 -0.94,-0.38 -1.33,-0.65 -0.31,-0.22 -0.24,-0.31 -0.24,-0.76 0,-0.33 0,-0.68 -0.01,-1.01 -0.22,-0.09 -0.54,-0.36 -0.72,-0.54l-0.24 -0.21c-0.01,0.6 -0.01,1.2 -0.01,1.79 0,0.65 -0.09,1.11 0.23,1.6 0.37,0.57 1.41,1.07 2.21,1.42 2.05,0.89 6.63,1.64 8.95,1.92 0.32,0.04 1.4,0.26 1.55,0.05 0.1,-0.13 0.06,-1.49 0.05,-1.77l0.01 -16.28c-0.01,-0.54 0.08,-1.2 -0.2,-1.62 -0.4,-0.64 -1.38,-1.02 -2.29,-1.34 -2.09,-0.73 -9.04,-2.48 -10.25,-3.78l-0.25 -0.23c-0.05,5.58 0.02,11.17 0,16.75 -0.01,0.48 0.5,0.99 0.83,1.25 1.19,0.93 3.04,1.4 4.55,1.75 1.61,0.38 3.6,0.78 5.27,1.04 0.57,0.09 1.23,0.17 1.8,0.29z"
      />
      <path
        class="fil0"
        d="M19.95 16.55c-1.85,0.13 -3.36,1.11 -4.22,2.04 -0.53,0.58 -0.9,1.1 -1.21,1.89 -0.82,2.07 -0.54,4.35 0.74,6.14 1.71,2.4 5.24,3.06 7.89,1.8 0.42,-0.21 1.05,-0.61 1.4,-0.93 2.08,-1.96 2.56,-4.89 1.36,-7.52 -0.24,-0.52 -0.57,-0.99 -0.93,-1.4 -0.63,-0.72 -1.29,-1.22 -2.31,-1.63 -0.83,-0.33 -1.75,-0.46 -2.72,-0.39z"
      />
      <path
        class="fil0"
        d="M5.59 3.9l0.01 -2.14 14.53 0 0 14.01c0.28,0.01 0.56,0 0.84,0.02 0.22,0.01 0.57,0.08 0.76,0.07 0.03,-0.38 0.01,-5.33 0,-5.85 0,-1.96 0.01,-3.93 0,-5.9 0,-0.48 0.04,-2.61 -0.02,-2.9 -0.07,-0.41 -0.33,-0.73 -0.56,-0.91 -0.34,-0.27 -0.63,-0.3 -1.16,-0.3l-17.66 0c-0.52,0 -0.85,-0.01 -1.31,0.16 -0.39,0.13 -0.69,0.35 -0.86,0.61 -0.33,0.5 -0.07,0.73 0.23,0.97 0.25,0.19 0.61,0.41 0.93,0.56 0.65,0.32 1.36,0.61 2.07,0.87 0.32,0.11 1.99,0.73 2.2,0.73z"
      />
      <text x="15.87" y="26.8" class="fil1 fnt0">C</text>
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
